<template>
  <div>
    <v-form
      ref="form"
      :lazy-validation="true"
    >
      <v-row>
        <v-col
          cols="6"
          sm="6"
          md="6"
        >
          <v-card-text class="pa-0">
            <ApplicationStateSelect
              label
              :disabled="get(currentUser, 'userrole.isRegionary', false)"
              :companyApplicant="isCompanyApplication"
              v-model="objLocal.stateId"
              :rules="[rules.required]"
            />
          </v-card-text>
        </v-col>
        <v-col
          cols="6"
          sm="6"
          md="6"
        >
          <v-select
            data-cy="select-application-region"
            v-model="selectedApplication.regionId"
            :items="basicRegions"
            outlined
            item-text="name"
            item-value="id"
            label="BYN-Region"
          ></v-select>
        </v-col>
      </v-row>
      <v-btn
        color="secondary"
        @click="showProcessModal"
      >
        <v-icon>$sl-info</v-icon>VISA VAR I PROCESSEN ANMÄLAN BEFINNER SIG
      </v-btn>
    </v-form>

    <ApplicationInfoModal
      @close="showInfo = !showInfo"
      :showInfo="showInfo"
      :application="selectedApplication"
    />

    <ChangeStatusModal
      :changedStatus="objLocal"
      :show="showMessage"
      @send="doSaveObj"
      @close="showMessage = false"
    />
  </div>
</template>

<script>
import get from 'lodash/get'
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import {RulesMixin, ApplicationModal, ApplicationValidation} from '@/components/mixins'
import ChangeStatusModal from '@/components/application/ChangeStatusModal'
import ApplicationInfoModal from '@/components/application/ApplicationInfoModal'
import ApplicationStateSelect from '@/components/application/ApplicationStateSelect'

export default {
  name: 'ApplicationStatusEdit',

  props: {
    obj: {
      type: Object,
      required: true
    }
  },

  model: {
    prop: 'obj',
    event: 'objchange'
  },

  mixins: [RulesMixin, ApplicationModal, ApplicationValidation],

  components: {
    ChangeStatusModal,
    ApplicationInfoModal,
    ApplicationStateSelect
  },

  data: () => ({
    showMessage: false
  }),

  computed: {
    objLocal: {
      get() {
        return this.obj
      },

      set(value) {
        this.$emit('objchange', value)
      }
    },

    ...mapGetters('application', ['selectedApplication', 'applicationCompany', 'isCompanyApplication']),
    ...mapGetters('basic', ['basicRegions']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole'])
  },

  methods: {
    get,

    saveObj() {
      console.log('ApplicationStatus - saveObj')

      //- Trigger validations and bug out on invalid
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      if (!this.isValidStateChange(this.objLocal.stateId, this.selectedApplication)) {
        this.$events.fire(
          'showError',
          'Du behöver komplettera anmälan med mer information för att kunna byta till vald status.'
        )
        return
      }
      if (this.objLocal.stateId !== this.selectedApplication.stateId) {
        this.showMessage = true
      } else {
        this.doSaveObj()
      }
    },

    /**
     * @vuese
     * Used to change state application
     */
    async doSaveObj() {
      console.log('ApplicationStatus - doSaveObj')
      this.showMessage = false

      //let notification = (messageOpts.sendMessage && messageOpts.message) ? {text: messageOpts.message} : null
      if (this.selectedApplication.stateId != this.objLocal.stateId) {
        // API.changeStateApplication(this.obj.id, {data: merge(this.obj, {notification: notification})})
        API.changeStateApplication(this.objLocal.id, {data: this.objLocal})
          .then(response => {

            /**
             * @vuese
             * Used to update application in vuex store with the application state changed
             */
            // TODO: do we wand to fetch actual data, or du we want to manually mutate the store?
            // this.updateSelectedApplication(this.obj)
            this.$events.fire('showInfo', 'Anmälan updaterad.')
            this.objLocal = this.selectedApplication
            this.$emit('saved')
            this.editing = false
          })
          .catch(error => {
            console.log('There was an error:', error)
            return this.handleOrderingErrors(error)
          })
      } else if (this.selectedApplication.regionId != this.objLocal.regionId) {
        API.updateApplication(this.selectedApplication.id, {
          data: this.selectedApplication
        })
          .then(response => {

            /**
             * @vuese
             * Used to update application in vuex store with the application state changed
             */
            // TODO: do we wand to fetch actual data, or du we want to manually mutate the store?
            // this.updateSelectedApplication(this.obj)
            this.$events.fire('showInfo', 'Anmälan updaterad.')
            this.objLocal = this.selectedApplication
            this.$emit('saved')
            this.editing = false
          })
          .catch(error => {
            console.log('There was an error:', error)
            return this.handleOrderingErrors(error)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>